import Card1 from "./Card1";
import Card2 from "./Card2";
import Card3 from "./Card3";
import Card4 from "./Card4";
import Card5 from "./Card5";
export const cards = {
  card1: Card1,
  card2: Card2,
  card3: Card3,
  card4: Card4,
  card5: Card5,
};